"use strict";
// FixedLimit.ts
//
// Implementation for the Fix Limit. Every player is allowed to bet only the specified amount
Object.defineProperty(exports, "__esModule", { value: true });
exports.FixedLimit = void 0;
const BettingStructure_1 = require("./BettingStructure");
/**
 * Fixed Limit
 *
 * Every player should bet/raise predetermine fixed amount
 */
class FixedLimit extends BettingStructure_1.BettingStructure {
    constructor(prefs) {
        super(prefs);
        this.validatePositiveNumber(prefs.fixedLimitAmount, "fixedLimitAmount");
        this.limitAmount = prefs.fixedLimitAmount;
    }
    validateBet(bet, round) {
        this.validatePositiveNumber(bet.amount, "bet amount");
        if (bet.raise > 0 && bet.amount !== this.limitAmount) {
            throw new Error(`Illegal amount: ${bet.amount} for fixed limit: ${this.limitAmount}`);
        }
        this.validateRaises(bet, round);
        this.validateBetSize(bet, round);
    }
}
exports.FixedLimit = FixedLimit;
//# sourceMappingURL=FixedLimit.js.map